export const PL_PLAYERS = [
  'david-raya-martin-2024-limited-426',
  'ederson-santana-de-moraes-2024-limited-450',
  'damian-emiliano-martinez-2024-limited-422',
  'nick-pope-2024-limited-431',
  'mark-flekken-2024-limited-445',
  'matz-sels-2024-limited-441',
  'bart-verbruggen-2024-limited-473',
  'jordan-pickford-2024-limited-448',
  'dean-henderson-2024-limited-454',
  'andre-onana-2024-limited-586',
  'kepa-arrizabalaga-revuelta-2024-limited-600',
  'bernd-leno-2024-limited-4',

  'cristian-gabriel-romero-2024-limited-409',
  'gabriel-dos-santos-magalhaes-2024-limited-423',
  'josko-gvardiol-2024-limited-402',
  'lewis-hall-2004-09-08-2024-limited-234',
  'neco-williams-2024-limited-488',
  'virgil-van-dijk-2024-limited-431',
  'ashley-young-2024-limited-435',
  'marc-guehi-2024-limited-257',
  'lisandro-martinez-2024-limited-21',
  'antonee-robinson-2024-limited-178',
  'william-saliba-2024-limited-630',
  'manuel-obafemi-akanji-2024-limited-578',
  'konstantinos-mavropanos-2024-limited-618',
  'andrew-robertson-2024-limited-589',
  'murillo-santiago-costa-dos-santos-2024-limited-571',
  'max-kilman-2024-limited-225',
  'nathan-michael-collins-2024-limited-734',
  'pervis-josue-estupinan-tenorio-2024-limited-681',

  'moises-isaac-caicedo-corozo-2024-limited-438',
  'philip-foden-2024-limited-455',
  'carlos-balepa-noom-quomah-2024-limited-346',
  'mikkel-damsgaard-2024-limited-356',
  'declan-rice-2024-limited-392',
  'bruno-guimaraes-rodriguez-moura-2024-limited-374',
  'emile-smith-rowe-2024-limited-407',
  'bruno-miguel-borges-fernandes-2024-limited-31',
  'kaoru-mitoma-2024-limited-541',
  'bernardo-mota-veiga-de-carvalho-e-silva-2024-limited-77',
  'cole-palmer-2024-limited-594',
  'eberechi-eze-2024-limited-588',
  'lucas-tolentino-coelho-de-lima-2024-limited-532',
  'sander-berge-2024-limited-621',
  'manuel-ugarte-ribeiro-2024-limited-516',
  'james-maddison-2024-limited-585',

  'luis-fernando-diaz-marulanda-2024-limited-389',
  'bryan-mbeumo-2024-limited-411',
  'chris-wood-2024-limited-425',
  'alexander-isak-2024-limited-418',
  'dominic-solanke-2024-limited-378',
  'erling-haland-2024-limited-435',
  'ollie-watkins-2024-limited-415',
  'jarrod-bowen-2024-limited-421',
  'joao-pedro-junqueira-de-jesus-2024-limited-15',
  'bukayo-saka-2024-limited-513',
  'mohamed-salah-ghaly-2024-limited-450',
  'amad-diallo-traore-2024-limited-469',
  'matheus-santos-carneiro-da-cunha-2024-limited-602',
  'ismaila-sarr-2024-limited-732',
  'heung-min-son-2024-limited-603',
  'chukwunonso-madueke-2024-limited-593',
  'jamie-vardy-2024-limited-558',
  'francisco-evanilson-de-lima-barbosa-2024-limited-582',
  'jean-philippe-mateta-2024-limited-540',
];

export const LALIGA_PLAYERS = [
  'sergio-herrera-piron-2024-limited-396',
  'rui-tiago-dantas-da-silva-2024-limited-384',
  'julen-agirrezabala-astulez-2024-limited-420',
  'thibaut-courtois-2024-limited-361',
  'ignacio-pena-sotorres-2024-limited-442',
  'jan-oblak-2024-limited-424',
  'alejandro-remiro-gargallo-2024-limited-414',
  'vicente-guaita-panadero-2024-limited-365',
  'karl-jakob-hein-2024-limited-244',
  'david-soria-solis-2024-limited-551',
  'sergio-herrera-piron-2024-limited-587',
  'marko-dmitrovic-2024-limited-484',

  'inigo-martinez-berridi-2024-limited-389',
  'naif-aguerd-2024-limited-310',
  'diego-javier-llorente-rios-2024-limited-374',
  'alejandro-catena-marugan-2024-limited-441',
  'florian-lejeune-2024-limited-451',
  'antonio-rudiger-2024-limited-360',
  'jose-maria-gimenez-de-vargas-2024-limited-360',
  'loic-bade-2024-limited-301',
  'yarek-gasiorowski-hernandis-2024-limited-255',
  'jules-kounde-2024-limited-544',
  'igor-zubeldia-elorza-2024-limited-634',
  'carl-starfelt-2024-limited-594',
  'ladislav-krejci-2024-limited-632',
  'yuri-berchiche-izeta-2024-limited-598',
  'juan-bernat-velasco-2024-limited-58',
  'nemanja-gudelj-2024-limited-438',

  'giovani-lo-celso-2024-limited-321',
  'marc-casado-torras-2024-limited-19',
  'martin-zubimendi-ibanez-2024-limited-394',
  'joao-lucas-de-souza-cardoso-2024-limited-347',
  'daniel-parejo-munoz-2024-limited-302',
  'jude-bellingham-2024-limited-434',
  'rodrigo-javier-de-paul-2024-limited-324',
  'moriba-kourouma-kourouma-2024-limited-262',
  'oihan-sancet-tirapu-2024-limited-388',
  'sergi-darder-moll-2024-limited-648',
  'pedro-gonzalez-lopez-2024-limited-598',
  'luis-milla-manzanares-2024-limited-481',
  'arda-guler-2024-limited-463',
  'alejandro-baena-rodriguez-2024-limited-501',
  'federico-santiago-valverde-dipetta-2024-limited-563',
  'dario-cassia-luis-essugo-2024-limited-466',
  'ergi-altimira-clavell-2024-limited-446',

  'raphael-dias-belloli-2024-limited-393',
  'vinicius-jose-paixao-de-oliveira-junior-2024-limited-430',
  'raul-moro-prescoli-2024-limited-417',
  'thierno-barry-2002-10-21-2024-limited-48',
  'takefusa-kubo-2024-limited-410',
  'nicholas-williams-arthuer-2024-limited-478',
  'antoine-griezmann-2024-limited-422',
  'iago-aspas-juncal-2024-limited-327',
  'lamine-yamal-nasraoui-ebana-2024-limited-464',
  'inaki-williams-arthuer-2024-limited-466',
  'kylian-mbappe-lottin-2024-limited-560',
  'mikel-oyarzabal-ugarte-2024-limited-514',
  'dodi-lukebakio-2024-limited-528',
  'ante-budimir-2024-limited-428',
  'julian-alvarez-2024-limited-299',
];

export const BUNDESLIGA_PLAYERS = [
  'kevin-trapp-2024-limited-395',
  'noah-atubolu-2024-limited-428',
  'moritz-nicolas-2024-limited-424',
  'manuel-neuer-2024-limited-375',
  'oliver-baumann-2024-limited-186',
  'alexander-nubel-2024-limited-291',
  'peter-gulacsi-2024-limited-449',
  'robin-zentner-2024-limited-402',
  'gregor-kobel-2024-limited-425',
  'michael-zetterer-2024-limited-611',
  'lukas-hradecky-2024-limited-275',
  'frederik-ronnow-2024-limited-248',
  'patrick-drewes-2024-limited-573',

  'keven-schlotterbeck-2024-limited-327',
  'min-jae-kim-2024-limited-415',
  'nico-schlotterbeck-2024-limited-408',
  'maximilian-mittelstadt-2024-limited-93',
  'lucas-silva-melo-2024-limited-368',
  'willi-orban-2024-limited-323',
  'alejandro-grimaldo-garcia-2024-limited-389',
  'konstantinos-koulierakis-2024-limited-196',
  'anthony-caci-2024-limited-436',
  'ko-itakura-2024-limited-197',
  'dayotchanculle-upamecano-2024-limited-543',
  'ramy-bensebaini-2024-limited-492',
  'anthony-rouault-2024-limited-509',
  'arthur-theate-2024-limited-424',
  'lutsharel-geertruida-2024-limited-503',
  'jonathan-tah-2024-limited-248',
  'marco-friedl-2024-limited-482',
  'matthias-ginter-2024-limited-510',

  'rocco-reitz-2024-limited-339',
  'jamal-musiala-2024-limited-413',
  'tom-bischof-2024-limited-370',
  'florian-wirtz-2024-limited-447',
  'felix-kalu-nmecha-2024-limited-391',
  'enzo-millot-2024-limited-355',
  'amadou-haidara-2024-limited-294',
  'julian-weigl-2024-limited-21',
  'jae-sung-lee-2024-limited-526',
  'michael-olise-2024-limited-596',
  'joshua-kimmich-2024-limited-547',
  'vincenzo-grifo-2024-limited-496',
  'granit-xhaka-2024-limited-273',
  'julian-brandt-2024-limited-595',
  'angelo-stiller-2024-limited-284',
  'christoph-baumgartner-2024-limited-664',
  'jackson-irvine-2024-limited-497',
  'nadiem-amiri-2024-limited-511',

  'omar-marmoush-2024-limited-377',
  'serhou-guirassy-2024-limited-381',
  'alexis-claude-maurice-2024-limited-89',
  'alassane-plea-2024-limited-345',
  'donyell-malen-2024-limited-8',
  'hugo-ekitike-2024-limited-414',
  'benjamin-sesko-2024-limited-431',
  'mohamed-el-amine-amoura-2024-limited-286',
  'jonathan-burkardt-2024-limited-433',
  'leroy-sane-2024-limited-535',
  'jamie-jermaine-bynoe-gittens-2024-limited-584',
  'tim-kleindienst-2024-limited-524',
  'marvin-ducksch-2024-limited-500',
  'lois-openda-2024-limited-255',
];
